module.exports = __webpack_public_path__ + "static/mtb-6-4bb47a84f87b0297397787a458a2e563.jpg";